"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrappedPropertyCtor = void 0;
exports.WrappedPropertyCtor = {};
exports.default = exports.WrappedPropertyCtor;
//# sourceMappingURL=WrappedPropertyCtor.js.map